module.exports = __webpack_public_path__ + "static/leads-ff33172e9655b6d6a183f43711450d21.jpg";